import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import FilePicker from '../../upload/FilePicker';
import { uploadAttachment as uploadApi } from '../../../api/Api';
import fetchAttachmentsCreator from '../../../redux/actions/attachments';
import { AUTH_LEVELS } from '../../auth/Authorized';

const styles = {
  attachmentUpload: {
    marginTop: '20px',
  },
};

class AttachmentUpload extends React.Component {
  state = {
    file: null,
    filename: null,
    uploadInFlight: false,
    message: '',
  };

  onFileSelection(e) {
    e.preventDefault();
    if (e.target.files.length !== 1) return;
    const file = e.target.files[0];
    this.setState({ file, filename: file.name });
  }

  onUploadClick() {
    const {
      fetchAttachments,
      user: { jwt },
      buildingId,
    } = this.props;
    const { file } = this.state;
    this.setState({ uploadInFlight: true, message: '' }, () =>
      uploadApi(buildingId, file, jwt)
        .then(() => this.setState({ file: null, filename: null }))
        .catch((e) => this.setState({ message: e.message }))
        .finally(() => {
          this.setState({ uploadInFlight: false });
          fetchAttachments(buildingId);
        })
    );
  }

  renderPreselect() {
    return (
      <div style={styles.attachmentUpload}>
        <FilePicker
          buttonText="Attach a file"
          selectedFileName=""
          onFileSelection={(e) => this.onFileSelection(e)}
        />
      </div>
    );
  }

  renderSelected() {
    const { filename, uploadInFlight, message } = this.state;
    return (
      <div style={styles.attachmentUpload}>
        <div>
          <Button
            disabled={uploadInFlight}
            color="primary"
            variant="contained"
            onClick={() => this.onUploadClick()}
          >
            Attach &quot;{filename}&quot;
          </Button>
        </div>
        <div style={{ marginTop: '10px' }}>
          {uploadInFlight ? (
            <LinearProgress color="secondary" />
          ) : (
            <Button
              variant="contained"
              onClick={() => this.setState({ file: null, filename: null })}
            >
              Cancel
            </Button>
          )}
        </div>
        <div style={{ marginTop: '10px' }}>
          <span>{message}</span>
        </div>
      </div>
    );
  }

  render() {
    const {
      user: { userAuthLevel },
    } = this.props;
    if (userAuthLevel > AUTH_LEVELS.ORG_ADMIN) return null;
    const { file } = this.state;
    return file == null ? this.renderPreselect() : this.renderSelected();
  }
}

AttachmentUpload.propTypes = {
  fetchAttachments: PropTypes.func.isRequired,
  buildingId: PropTypes.number.isRequired,
  user: PropTypes.shape({
    jwt: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(
  ({ user }) => ({ user }),
  (dispatch) => ({ fetchAttachments: (id) => dispatch(fetchAttachmentsCreator(id)) })
)(AttachmentUpload);
